/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import { useAlert } from 'react-alert';
import { useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { splitQuery } from '../../Shares/CommonUtil';
import { EventApi } from '../../Utils/Api/EventApi';
import { cdnUrlConfig } from '../../Utils/atoms';
import { initUnity, setUnityMember } from '../../Utils/unityUtil';
import Pagination from '../../Shares/Pagination';

const PAGE_SIZE = 4; // 댓글 페이지 사이즈

/**
 * [4월 이벤트] 플레이 소감 작성 이벤트: 댓글 작성 메인 페이지
 */
const EventMain = () => {
	const replyRef = useRef(); // 댓글 작성 영역으로 이동시켜주는 ref
	const alert = useAlert();
	const cdnUrl = useRecoilValue(cdnUrlConfig);
	const IMG_URL = `${cdnUrl}/BigglzEvent`;

	// 주소에서 event_se 가져오기
	const { search } = useLocation();
	const querys = splitQuery(search);
	const event_se = querys['event_se'] ? querys['event_se'] : 0;
	const [member_se, setMemberSe] = useState(0);
	const [page, setPage] = useState(1);
	const [totalCount, setTotalCount] = useState(0);
	const [replyList, setReplyList] = useState([]);
	const [textInput, setTextInput] = useState('');
	const [loading, setLoading] = useState(false);

	// member_se 세팅
	useEffect(() => {
		if (event_se > 0) {
			initUnity();
			setMemberSe(Number(window.GetMemberSE()));
		}
	});

	useEffect(() => {
		//이벤트 참여 컨텐츠 Load
		if (event_se > 0) {
			fetchData(page);
		}
	}, [page]);

	//#region 이벤트함수
	function fetchData(page) {
		//이벤트 컨텐츠 리스트 가져오기
		EventApi.getContent(event_se, page, PAGE_SIZE)
			.then((response) => {
				const { status, data } = response;
				if (status === 200) {
					setReplyList(data.datas);
					setTotalCount(data.count);
				}
			})
			.finally(() => {
				setTextInput('');
			});
	}

	function handlePageChange(value) {
		//페이지 변경 이벤트
		setPage(value);
		scrollToReplyWriteArea();
	}

	function scrollToReplyWriteArea() {
		// 댓글 작성 영역으로 스크롤 이동
		replyRef.current.scrollIntoView({ behavior: 'smooth' });
	}

	function handleChange(event) {
		//댓글 입력 이벤트
		const { value } = event.target;
		setTextInput(value);
	}

	function handleSubmit() {
		//댓글 게시 이벤트
		const { isValid, msg } = validCheck();

		if (isValid) {
			if (!loading) {
				setLoading(true);
				const submitData = {
					event_se: event_se,
					member_se: member_se,
					participate_event_ct: textInput,
				};

				EventApi.postContent(submitData)
					.then((response) => {
						const { status } = response;
						if (status === 200) {
							if (page > 1) {
								setPage(1);
							} else {
								fetchData(1);
							}
						}
					})
					.catch((error) => {
						const { data } = error.response;
						alert.error(`${data.msg}`);
					})
					.finally(() => {
						setLoading(false);
					});
			}
		} else {
			alert.error(msg);
		}
	}

	function validCheck() {
		//댓글 입력값 유효성 검사
		let isValid = true;
		let error = '';
		const minimumLength = 5;

		if (member_se === 0) {
			isValid = false;
			error = '회원정보를 알 수 없습니다.';
		} else if (textInput === '') {
			isValid = false;
			error = '입력된 내용이 없습니다.';
		} else if (textInput.length < minimumLength) {
			isValid = false;
			error = `${minimumLength}글자 이상 입력해주세요.`;
		}

		return { isValid, msg: error };
	}
	//#endregion

	return (
		<div id='wrap'>
			<div className='container'>
				<div className='content Review'>
					{/* 인트로 */}
					<div className='visual'>
						<h1>
							<img
								src={`${IMG_URL}/images/review/img_tit.png`}
								alt='4월 대규모 업데이트 플레이 소감 작성 이벤트'
							/>
						</h1>
						<div className='txt'>
							업데이트된 새 콘텐츠들을
							<span>플레이한 후 소감을 댓글로 작성해주세요!</span>
						</div>
						<button className='btn-write' onClick={scrollToReplyWriteArea}>
							댓글쓰기
						</button>{' '}
					</div>
					{/* 참여방법 */}
					<div className='event-info howto'>
						<h2>
							<span>참여방법</span>
						</h2>
						<div className='howto-area'>
							<ol>
								<li>
									<div className='tit'>STEP 1</div>
									<div className='txt'>
										4월 업데이트로 새로 추가된 콘텐츠 들을 플레이한다.
									</div>
								</li>
								<li>
									<div className='tit'>STEP 2</div>
									<div className='txt'>플레이한 후 소감을 댓글로 등록한다.</div>
								</li>
							</ol>
						</div>
					</div>
					{/* 업데이트 콘텐츠 */}
					<div className='event-info update'>
						<h2>업데이트 콘텐츠</h2>
						<div className='update-area'>
							<ul>
								<li>
									<figure>
										<img
											src={`${IMG_URL}/images/review/img_update1.png`}
											alt='펫하우스'
										/>
										<figcaption>펫하우스</figcaption>
									</figure>
								</li>
								<li>
									<figure>
										<img
											src={`${IMG_URL}/images/review/img_update2.png`}
											alt='청소하기'
										/>
										<figcaption>청소하기</figcaption>
									</figure>
								</li>
								<li>
									<figure>
										<img
											src={`${IMG_URL}/images/review/img_update3.png`}
											alt='미션 및 업적'
										/>
										<figcaption>미션 및 업적</figcaption>
									</figure>
								</li>
								<li>
									<figure>
										<img
											src={`${IMG_URL}/images/review/img_update4.png`}
											alt='샤워하기'
										/>
										<figcaption>샤워하기</figcaption>
									</figure>
								</li>
								<li>
									<figure>
										<img
											src={`${IMG_URL}/images/review/img_update5.png`}
											alt='채집하기'
										/>
										<figcaption>채집하기</figcaption>
									</figure>
								</li>
								<li>
									<figure>
										<img
											src={`${IMG_URL}/images/review/img_update6.png`}
											alt='무료충전소'
										/>
										<figcaption>무료충전소</figcaption>
									</figure>
								</li>
								<li>
									<figure>
										<img
											src={`${IMG_URL}/images/review/img_update7.png`}
											alt='랜덤박스'
										/>
										<figcaption>랜덤박스</figcaption>
									</figure>
								</li>
								<li>
									<figure>
										<img
											src={`${IMG_URL}/images/review/img_update8.png`}
											alt='펫팔파이브'
										/>
										<figcaption>펫팔파이브</figcaption>
									</figure>
								</li>
								<li>
									<figure>
										<img
											src={`${IMG_URL}/images/review/img_update9.png`}
											alt='마음의소리'
										/>
										<figcaption>마음의소리</figcaption>
									</figure>
								</li>
								<li>
									<figure>
										<img
											src={`${IMG_URL}/images/review/img_update10.png`}
											alt='핀고정'
										/>
										<figcaption>핀고정</figcaption>
									</figure>
								</li>
							</ul>
						</div>
					</div>
					{/* 이벤트 상세 기간 안내 */}
					<div className='event-info detail'>
						<h2>이벤트 상세 안내</h2>
						<div className='info-area'>
							<ul>
								<li>
									<div className='tit-info'>참여기간</div>
									<div className='txt'>2023년 4월 1일 ~ 4월 30일</div>
								</li>
								<li>
									<div className='tit-info'>발표일</div>
									<div className='txt'>2023년 5월 7일</div>
								</li>
								<li>
									<div className='tit-info'>심사기준</div>
									<div className='txt'>
										플레이 소감을 정성껏 작성해
										<span>주신 분들 중 추첨합니다.</span>
									</div>
								</li>
							</ul>
						</div>
					</div>
					{/* 경품안내 */}
					<div className='event-info product'>
						<h2>
							<span>경품안내</span>
						</h2>
						<ol>
							<li>
								<div className='photo'>
									<figure>
										<img
											src={`${IMG_URL}/images/review/img_rewards1.png`}
											alt='GS25 모바일 상품권 10,000원'
										/>
										<figcaption>GS25 모바일 상품권 10,000원 (20명)</figcaption>
									</figure>
								</div>
								<div className='rank top1'>추첨</div>
								<div className='name'>GS25 모바일 상품권 10,000원 (20명)</div>
							</li>
							<li>
								<div className='photo'>
									<figure>
										<img
											src={`${IMG_URL}/images/review/img_rewards2.png`}
											alt='젤리 20개'
										/>
										<figcaption>젤리 20개</figcaption>
									</figure>
								</div>
								<div className='rank top2'>2등</div>
								<div className='name'>젤리 20개</div>
							</li>
						</ol>
					</div>
					{/* 댓글  */}
					<div className='event-info action'>
						{/* 입력칸 */}
						<div className='txt-box'>
							<div className='txt-area'>
								<textarea
									placeholder='내용을 입력해주세요(300자 이하)'
									maxLength={300}
									value={textInput}
									onChange={handleChange}
									ref={replyRef}
								/>
							</div>
							<button className='btn-send' onClick={handleSubmit}>
								입력
							</button>
						</div>
						{/* 댓글리스트 */}
						<div className='comment-box'>
							<div className='comment-area'>
								<ul>
									{replyList.map((reply) => (
										<li key={reply.event_member_se}>
											<div className='user-info'>
												<div className='user'>
													<div className='photo'>
														{reply.member_profile ? (
															<img
																src={cdnUrl + reply.member_profile}
																alt={reply.member_profile}
															/>
														) : (
															<img
																src={`${IMG_URL}/images/gameking/profile/${reply.pet_profile}`}
																alt={reply.pet_profile}
															/>
														)}
													</div>
													<div className='name'>{reply.nick_nm}</div>
												</div>
												<div className='date'>{reply.reg_date}</div>
											</div>
											<div className='comment-content'>
												{reply.participate_event_ct
													.split('\n')
													.map((content, index) => {
														const maxTextLengthPerLine = 23; // 한 줄에 표출되는 최대 글자수
														const line = Math.floor(
															content.length / maxTextLengthPerLine
														);
														if (line > 0) {
															for (let i = 0; i < line; i++) {
																return (
																	<div
																		key={index}
																		style={{
																			wordBreak: 'break-all',
																		}}
																	>
																		{content} <br />
																	</div>
																);
															}
														} else
															return (
																<React.Fragment key={index}>
																	{content} <br />
																</React.Fragment>
															);
													})}
											</div>
										</li>
									))}
								</ul>
							</div>
							<div className='pagination'>
								{totalCount > 0 && (
									<Pagination
										currentPage={page}
										totalCount={totalCount}
										pageSize={PAGE_SIZE}
										onChange={handlePageChange}
									/>
								)}
							</div>
						</div>
					</div>
					{/* 주의사항 */}
					<div className='cautionary'>
						<dl>
							<dt>확인해주세요</dt>
							<dd>이벤트 중복 참여 시 1회만 이벤트 참여로 인정됩니다.</dd>
							<dd>
								비글즈 플레이와 관련된 후기만 이벤트 대상이 되며, 관련 없는 글은
								추첨 대상에서 제외될 수 있습니다.{' '}
							</dd>
							<dd>
								이벤트에 당첨되신 분들은 꼭 당첨자 발표 7일 이내로 마이페이지
								&gt; 설정 &gt; 고객센터 1:1 문의 접수 혹은 운영자 이메일 개별
								연락을 통해 휴대전화 번호 혹은 주소를 보내주셔야 합니다.
							</dd>
							<dd>
								기간 내 문의를 접수해 주시지 않을 경우 당첨이 취소될 수
								있습니다.
							</dd>
							<dd>
								이벤트 기간 동안 닉네임 변경 시 당첨정보 확인이 불가하여 당첨이
								취소될 수 있습니다.
							</dd>
							<dd>이벤트 상품은 교환 및 환불이 불가합니다.</dd>
							<dd>기프티콘 선물은 유효 기간 내에 사용해 주셔야 합니다.</dd>
							<dd>
								해당 이벤트는 앱스토어 또는 구글 플레이스토어 등과 무관합니다.
							</dd>
						</dl>
					</div>
				</div>
			</div>
		</div>
	);
};

export default EventMain;
